import { render, staticRenderFns } from "./LeadsProgress.vue?vue&type=template&id=2092c20a&scoped=true&"
import script from "./LeadsProgress.vue?vue&type=script&lang=ts&"
export * from "./LeadsProgress.vue?vue&type=script&lang=ts&"
import style0 from "./LeadsProgress.vue?vue&type=style&index=0&id=2092c20a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2092c20a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VIcon,VProgressLinear,VRow})
